<template>
  <div class="modal fade" id="productDownload" role="dialog" @click="$emit('close')">
    <div class="modal-dialog" @click.stop>
      <div class="modal-content w-500">
        <div class="modal-header bg-color-info">
          <button type="button" class="close close-btn" data-dismiss="modal" @click="$emit('close')"> &times;</button>
        </div>
        <div class="modal-body">
          <div v-html="getModalmessage"></div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-warning w-150" data-dismiss="modal" @click="$emit('download')">ダウンロード</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      getModalmessage: `商品レポート（CSV）をダウンロードします。<br/> よろしければ「ダウンロード」ボタンを押してください。`
    }
  },
  mounted () {
    $('#productDownload').modal('show')
  }
}
</script>



// WEBPACK FOOTER //
// src/view/productsNew/ProductNewModalDownload.vue